import React from "react";
import {NewsletterEditionStatus} from "../types/newsletterEdition";
import {Pencil, Settings, Clock, CheckCircle, Send, Rocket, CalendarX} from "lucide-react";

const pillStyling: Record<
  NewsletterEditionStatus,
  {
    bgColor: string;
    textColor: string;
    icon: React.ReactNode;
  }
> = {
  [NewsletterEditionStatus.Preparing]: {
    bgColor: "#e5e7eb",
    textColor: "#374151",
    icon: <Pencil size={16} />,
  },
  [NewsletterEditionStatus.Finalizing]: {
    bgColor: "#ccfbf1",
    textColor: "#0f766e",
    icon: <Settings size={16} />,
  },
  [NewsletterEditionStatus.AwaitingApproval]: {
    bgColor: "#fef9c3",
    textColor: "#854d0e",
    icon: <Clock size={16} />,
  },
  [NewsletterEditionStatus.Approved]: {
    bgColor: "#dcfce7",
    textColor: "#166534",
    icon: <CheckCircle size={16} />,
  },
  [NewsletterEditionStatus.Sending]: {
    bgColor: "#dbeafe",
    textColor: "#1e40af",
    icon: <Send size={16} />,
  },
  [NewsletterEditionStatus.Published]: {
    bgColor: "#e8e8fe",
    textColor: "#5d5ded", // potions purple
    icon: <Rocket size={16} />,
  },
  [NewsletterEditionStatus.Expired]: {
    bgColor: "#fee2e2",
    textColor: "#991b1b",
    icon: <CalendarX size={16} />,
  }
};

const approveButtonStyle = {
  color: "#4caf50",
  cursor: "pointer"
};

const removeApprovalButtonStyle = {
  color: "#e02f2f",
  cursor: "pointer"
};

interface NewsletterStatusProps {
  status: NewsletterEditionStatus;
  handleUpdate: () => Promise<void>;
  canApproveFromPreparing?: boolean;
}

const NewsletterStatusPill: React.FC<NewsletterStatusProps> = (props: NewsletterStatusProps) => {
  const {status, handleUpdate, canApproveFromPreparing} = props;
  const {bgColor, textColor, icon} = pillStyling[status];

  return (
    <div className="newsletter-status-container">
      <span
        className="newsletter-status"
        style={{backgroundColor: bgColor, color: textColor}}>
        <span className="newsletter-status-icon">{icon}</span>
        <span>{status}</span>
      </span>
      {((status === NewsletterEditionStatus.Preparing && canApproveFromPreparing) || status === NewsletterEditionStatus.AwaitingApproval || status === NewsletterEditionStatus.Expired) && (
        <button
          className="tertiary-info-button"
          style={approveButtonStyle}
          onClick={(e) => {
            e.stopPropagation();
            handleUpdate();
          }}>
          Approve
        </button>
      )}
      {status === NewsletterEditionStatus.Approved && (
        <button
          className="tertiary-info-button"
          style={removeApprovalButtonStyle}
          onClick={(e) => {
            e.stopPropagation();
            handleUpdate();
          }}>
          Remove Approval
        </button>
      )}
    </div>
  );
};

export default NewsletterStatusPill;
